import API from './api'

const BASE_re_path = process.env.REACT_APP_re_path_PATH;

const getHeaders = () => {
    
    return { 'Content-Type': 'application/x-www-form-urlencoded' }
}

export const resetPassword = (obj) => {
    return API.post(BASE_re_path + '/dj-rest-auth/password/reset/', obj)
}

export const confirmResetPassword = (obj) => {
    return API.post(BASE_re_path + '/dj-rest-auth/password/reset/confirm/', obj)
}

export const checkField= (value)=>{
    const formData = new URLSearchParams();
    formData.append('email', value);
    return API.post(BASE_re_path + '/check-field/', formData   ,{ headers: getHeaders() })
        
    
}
